module.exports = __webpack_public_path__ + "static/media/icon_specs-material.63cbe2a1.svg";